import { render } from "./ConnectWallet.vue?vue&type=template&id=3b17a450&scoped=true"
import script from "./ConnectWallet.vue?vue&type=script&lang=js"
export * from "./ConnectWallet.vue?vue&type=script&lang=js"

import "./ConnectWallet.vue?vue&type=style&index=0&id=3b17a450&scoped=true&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b17a450"]])

export default __exports__